import Smooth from 'smoothscroll'
export default () => {
  const buttons = document.querySelectorAll('.js-smooth-scroll')
  if (!buttons || buttons.length === 0) return;
  [ ...buttons ].forEach(button => {
    button.addEventListener('click', e => {
      const { target } = button.dataset
      if (!target) return
      Smooth(document.getElementById(target).clientHeight, 500)
      e.preventDefault()
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/SmoothScroll.js